import {useParams} from "react-router";
import {useAppTranslation} from "@mybake/ui/hooks/useAppTranslation";
import {orderAPI} from "../../../services/OrderServices";
import {Box, Button} from "@mui/material";
import EditOrderV2 from "./EditOrderV2";
import {useNavigate} from "react-router-dom";
import {useLocation} from "react-router-dom";
import {ContentSkeleton} from '../../common/loading/ContentSkeleton';
import {customerAPI} from '../../../services/CustomerServices';
import {toOrderFormModel} from '../../../mappers/orderGuid.mapper';

export const EditOrderHOC = () => {
    const {id} = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const returnPath = (location.state as {returnPath?: string; fromOrdersList?: boolean} | null)?.returnPath;
    const fromOrdersList = !!(location.state as {fromOrdersList?: boolean} | null)?.fromOrdersList;
    const handleReturn = returnPath
        ? () => navigate(returnPath)
        : fromOrdersList
            ? () => navigate('/app/orders')
            : () => navigate("..", {relative: "path"});
    const {t} = useAppTranslation();
    const {
        data: order,
        isError: orderByIdIsError,
        isLoading: orderByIdIsLoading,
        isSuccess: orderByIdIsSuccess
    } = orderAPI.useGetOrderV2Query(id || '', {skip: !id});
    const {data: customer} = customerAPI.useGetCustomerByIdV2Query(order?.customerId ?? '', {skip: !order?.customerId});
    const formOrder = order && customer ? toOrderFormModel(order, customer as any) : undefined;

    return (<Box>
        {orderByIdIsLoading && <ContentSkeleton variant="form"/>}
        {formOrder && !orderByIdIsLoading &&
            <Box sx={{width: '100%'}}>
                <Button variant="outlined" onClick={handleReturn}>
                    {t('orders:back_to_orders')}
                </Button>
                <EditOrderV2 order={formOrder} onSaved={returnPath || fromOrdersList ? handleReturn : undefined}/>
            </Box>}
    </Box>);
};
